
import { getFirebase } from '../config/firebase';

export const useFirebase = () => getFirebase();
